import ProjectSession from "../../../model2/project/project-session";
import React, {useState} from "react";
import {ProjectAccessMode} from "../../../model2/project/types";
import {ProjectAccess} from "../../../gd/const/project";
import FieldWorkspaceAccess from "../../../fields3/system/project/access/workpace-access";
import {FieldType} from "../../../fields3/field-type";
import FieldProjectAccess from "../../../fields3/system/project/access/project-access";
import FieldFormElementView from "../../../fields3/render/form-elemnent-view";
import TeamsToAdd from "../../teams/model/collection";
import {TeamToAdd} from "../../teams/model/add-team";


type Props = {
    className?              : string

    targetProject?          : ProjectSession
    teamsToAddToWorkspace   : TeamsToAdd
    teamsToAddToProject     : TeamsToAdd

    showProjectAccess       : boolean
    showWorkspaceAccess     : boolean
}

export default function Modal_addTeams(props: Props) {
    const [renderKey, setRenderKey] = useState(0)

    const isInheritanceChildren = props.targetProject?.workspace?.project.accessMode === ProjectAccessMode.INHERITANCE_CHILDREN

    const onWorkspaceAccessChange = (teamToAdd: TeamToAdd, access:ProjectAccess) => {
        teamToAdd.workspaceAccess = access

        if (isInheritanceChildren) {
            // project access can't be lower than workspace access in INHERITANCE_CHILDREN
            if (!teamToAdd.projectAccess || teamToAdd.projectAccess < teamToAdd.workspaceAccess) {
                teamToAdd.projectAccess = teamToAdd.workspaceAccess
            }
        }

        setRenderKey(renderKey + 1)
    }

    const onProjectAccessChange = (teamToAdd: TeamToAdd, access:ProjectAccess) => {
        teamToAdd.projectAccess = access
        setRenderKey(renderKey + 1)
    }

    const workspaceAccessField = new FieldWorkspaceAccess({
        type            : FieldType.WORKSPACE_ACCESS,
        fieldId         : 'workspaceAccess'
    })

    const projectAccessField = new FieldProjectAccess({
        type            : FieldType.PROJECT_ACCESS,
        fieldId         : 'projectAccess',
        minAccess       : ProjectAccess.LIMITED
    })

    return (
        <div className="m-b-30">
            <div className={Classes("ui5-tabled-dashed w-100p", props.className)}>
                <div className="table-header">
                    <div className="cell flex-1">
                        <div className="ui5-title-small">
                            Teams
                        </div>
                    </div>

                    {props.showWorkspaceAccess &&
                        <div className="cell w-160">
                            <div className="ui5-grid-header">
                                Workspace Access
                            </div>
                        </div>}

                    {props.showProjectAccess &&
                        <div className="cell w-160">
                            <div className="ui5-grid-header">
                                Project Access
                            </div>
                        </div>}
                </div>

                {/*It's when move projects*/}
                {_.map(props.teamsToAddToWorkspace.available, (teamToAdd: TeamToAdd, key:number)=>{
                    const projectAccessFieldClone = _.cloneDeep(projectAccessField)
                    // project access can't be lower than workspace access in INHERITANCE_CHILDREN
                    if (props.targetProject?.workspace?.project.accessMode === ProjectAccessMode.INHERITANCE_CHILDREN) {
                        projectAccessFieldClone.minAccess = teamToAdd.workspaceAccess
                    }

                    return (
                        <div className="table-row" key={'{0}_{1}'.f(key, renderKey)}>
                            <div className="cell flex-1 flex-row-left-center">
                                <div className="ui5-ico-20 i5-team m-r-8"></div>
                                <div className="ui5-txt-default">{teamToAdd.team.name}</div>
                            </div>

                            <div className="cell w-160">
                                <FieldFormElementView className = "w-140"
                                                      field     = {workspaceAccessField}
                                                      options   = {{size: '30'}}
                                                      model     = {teamToAdd}
                                                      onChange  = {onWorkspaceAccessChange.bind(null, teamToAdd)}/>
                            </div>

                            {props.showProjectAccess &&
                                <div className="cell w-160">
                                    <FieldFormElementView className = "w-140"
                                                          field     = {projectAccessFieldClone}
                                                          options   = {{size: '30'}}
                                                          model     = {teamToAdd}
                                                          onChange  = {onProjectAccessChange.bind(null, teamToAdd)}/>
                                </div>}
                        </div>
                    )
                })}

                {/*It's when move tasks*/}
                {props.showProjectAccess && _.map(props.teamsToAddToProject.available, (teamToAdd: TeamToAdd, key:number)=>{
                    return (
                        <div className="table-row" key={'{0}_{1}'.f(key, renderKey)}>
                            <div className="cell flex-1 flex-row-left-center">
                                <div className="ui5-ico-20 i5-team m-r-8"></div>
                                <div className="ui5-txt-default">{teamToAdd.team.name}</div>
                            </div>

                            <div className="cell w-160">
                                <FieldFormElementView className = "w-140"
                                                      field     = {projectAccessField}
                                                      options   = {{size: '30'}}
                                                      model     = {teamToAdd}
                                                      onChange  = {onProjectAccessChange.bind(null, teamToAdd)}/>
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
